import { useState, useMemo } from 'react';
import { validateGeneralInfo, validateSourceFile, validateValidations, pgpDecryptionValidations } from "../../../utils/formValidations";

export const useConfirmationValidation = (formData: any) => {
  const [showOverrideWarning, setShowOverrideWarning] = useState(false);

  //helpers that verify all required fields are filled
  const isGeneralComplete = useMemo(() => validateGeneralInfo(formData), [formData]);
  const isSourceFileComplete = useMemo(() => validateSourceFile(formData), [formData]);
  const isValidationsComplete = useMemo(() => validateValidations(formData), [formData]);
  const isPgpDecryptionComplete = useMemo(() => pgpDecryptionValidations(formData), [formData]);

  const canSave = isGeneralComplete && isSourceFileComplete && isValidationsComplete && isPgpDecryptionComplete;
                 
  const incompleteSections = useMemo(() => {
    const sections = [];
    if (!isGeneralComplete) sections.push("General Information");
    if (!isSourceFileComplete) sections.push("Source File");
    if (!isValidationsComplete) sections.push("Validations");
    if (!isPgpDecryptionComplete) sections.push("PGP Decryption");
    return sections;
  }, [isGeneralComplete, isSourceFileComplete, isValidationsComplete, isPgpDecryptionComplete]);

  return {
    isGeneralComplete,
    isSourceFileComplete,
    isValidationsComplete,
    isPgpDecryptionComplete,
    canSave,
    incompleteSections,
    showOverrideWarning,
    setShowOverrideWarning
  };
};